import React from 'react';
import styled from 'styled-components';
import Tooltip from 'components/shared/Tooltip/Tooltip';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon';

interface IDisclaimer {
    disclaimer: string;
}

const IconContainer = styled.span`
    margin-left: ${({ theme }) => theme.Spacing8};
`;

const StyledIcon = styled(Icon)`
    display: block;
    pointer-events: all;
`;

function TooltipContent({ disclaimer }: IDisclaimer) {
    return <Typography.Body size="S">{disclaimer}</Typography.Body>;
}

export default function Disclaimer({ disclaimer }: IDisclaimer): JSX.Element {
    return (
        <Tooltip type="secondary" contentRenderer={() => <TooltipContent disclaimer={disclaimer} />}>
            {(props) => (
                <IconContainer {...props}>
                    <StyledIcon type="Information" size={16} aria-hidden />
                </IconContainer>
            )}
        </Tooltip>
    );
}
